export default {
  name: 'marking--pdInformationPermitDocType',
};
